import { formatIsoDate } from './format-date.js';

export type SfAuftragFelder = {
  sf_projektstatus?: string | null | undefined;
  sf_projektstart?: string | null | undefined;
  sf_projektende?: string | null | undefined;
};

/**
 * Eine Zeile „SF: läuft · 02.01.2026 – 31.07.2026" je Auftrag im Reiter „Aufträge" (PV-052 L2).
 * Macht sichtbar, WELCHER Auftrag einen Schließ-Check auslöst — auch bei einem CR, dessen Daten
 * die Karte „Salesforce-Daten" (nur führender Auftrag) nicht zeigt. `null`, wenn SF nichts liefert.
 */
export function sfAuftragZeile(a: SfAuftragFelder, sprache: string): string | null {
  const teile: string[] = [];
  if (a.sf_projektstatus) teile.push(a.sf_projektstatus);
  const start = a.sf_projektstart ? formatIsoDate(a.sf_projektstart, sprache) : null;
  const ende = a.sf_projektende ? formatIsoDate(a.sf_projektende, sprache) : null;
  if (start || ende) teile.push(`${start ?? '…'} – ${ende ?? '…'}`);
  return teile.length > 0 ? `SF: ${teile.join(' · ')}` : null;
}
